export class ChangeShowAvatar {
   public static readonly type = '[DirectoryDetailsSettings] Change show avatar';

   constructor(public brickInstanceId, public showAvatar: boolean) {}
}

export class ChangeVisibleFields {
   public static readonly type = '[DirectoryDetailsSettings] Change visible fields';

   constructor(public brickInstanceId, public visibleFields: string[]) {}
}

export class ChangeShowFieldNames {
   public static readonly type = '[DirectoryDetailsSettings] Change show field names';

   constructor(public brickInstanceId, public showFieldNames: boolean) {}
}
